import { View } from 'react-native';
import {
  Button,
  HelperText,
  Text,
  TextInput,
  useTheme,
} from 'react-native-paper';
import { useForm, Controller } from 'react-hook-form';
import { db } from '../Firebase/firebase';
import { setDoc, doc } from 'firebase/firestore';
import MyImagePicker from '../components/imagePicker';
import { Business, Props } from '../types';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import {
  setBusinesses,
  setAddingBusiness,
  setWebModalShown,
} from '../redux/businessListSlice';
import 'react-native-get-random-values';
import { v4 as uuidv4 } from 'uuid';
import { setSnackbar } from '../redux/snackbarSlice';

interface IFormInput {
  name: string;
  address: string;
  status: string;
  notes: string;
}

export default function AddBusinessForm({ navigation }: Partial<Props>) {
  const theme = useTheme();
  const dispatch = useAppDispatch();

  const { businesses, addingBusiness } = useAppSelector(
    (state) => state.businessList
  );

  const { organization } = useAppSelector((state) => state.organization);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty, isValid },
  } = useForm<IFormInput>({
    defaultValues: {
      name: '',
      address: '',
      status: '',
      notes: '',
    },
  });
  const addNewBusiness = async (data: IFormInput) => {
    dispatch(setAddingBusiness(true));
    try {
      const uuid = uuidv4();
      await setDoc(
        doc(db, `organizations/${organization.id}/businesses`, uuid),
        {
          name: data.name,
          address: data.address,
          status: 'New',
          // TODO: this shouldnt be hardcoded
          latitude: 50,
          longitude: 50,
          placeId: 'ChIJIS6rglGxQYgRWD_jhsOEf0Y',
        }
      );
      const newBusiness = {
        id: uuid,
        name: data.name,
        address: data.address,
        status: 'New',
        latitude: 50,
        longitude: 50,
        placeId: 'ChIJIS6rglGxQYgRWD_jhsOEf0Y',
      } as Business;

      dispatch(setBusinesses([...businesses, newBusiness] as Business[]));
      dispatch(setAddingBusiness(false));
      dispatch(
        setSnackbar({
          severity: 'success',
          message: 'Business added successfully!',
        })
      );
      reset();
      if (navigation) {
        navigation.goBack();
      } else {
        dispatch(setWebModalShown('None'));
      }
    } catch (e) {
      console.error(e);
    }
  };
  const onSubmit = (data: IFormInput) => addNewBusiness(data);

  return (
    <View
      style={{
        paddingHorizontal: 40,
        marginVertical: 24,
      }}
    >
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <TextInput
            mode="flat"
            label="Business Name *"
            onChangeText={onChange}
            value={value}
            style={{ backgroundColor: 'transparent', marginBottom: 12 }}
            error={errors.name ? true : false}
          />
        )}
        name="name"
      />
      <HelperText
        type="error"
        visible={errors.name ? true : false}
        style={{ marginBottom: 12 }}
      >
        This is a required field.
      </HelperText>

      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <TextInput
            label="Address *"
            onChangeText={onChange}
            value={value}
            style={{ backgroundColor: 'transparent' }}
            error={errors.address ? true : false}
          />
        )}
        name="address"
      />
      <HelperText
        type="error"
        visible={errors.address ? true : false}
        style={{ marginBottom: 12 }}
      >
        This is a required field.
      </HelperText>

      <View style={{ marginVertical: 12 }}>
        <Text style={{ marginBottom: 4 }}>Upload Photos</Text>
        <MyImagePicker />
      </View>
      <Controller
        control={control}
        render={({ field: { onChange, value } }) => (
          <TextInput
            label="Notes"
            mode="outlined"
            multiline={true}
            onChangeText={onChange}
            value={value}
            // only android
            numberOfLines={5}
            style={{ marginBottom: 12 }}
          />
        )}
        name="notes"
      />

      <Button
        mode="contained"
        loading={addingBusiness}
        disabled={addingBusiness}
        color={theme.colors.primary}
        style={{ borderRadius: 4, marginTop: 12 }}
        textColor={theme.colors.onPrimary}
        onPress={handleSubmit(onSubmit)}
      >
        {addingBusiness ? '' : 'Save'}
      </Button>
    </View>
  );
}
